export const TYPES = {
  SET_DEFAULT_COMPUTER_ALL: "default_computer/SET_DEFAULT_COMPUTER_ALL",
  SET_DEFAULT_COMPUTER_OPEN_ADD:
    "default_computer/SET_DEFAULT_COMPUTER_OPEN_ADD",
  SET_DEFAULT_COMPUTER_SELECTED:
    "default_computer/SET_DEFAULT_COMPUTER_SELECTED",
};
